/*
 *** Usage in FO: OK
 *** Usage in PO: OK
 *** Usage in BO: NOT OK
 */

import PropTypes from 'prop-types';
import { Fragment } from 'react';
import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import onEnterPress from 'hb-react/shared/utils/onEnterPress';

const isItemClickable = (tab) => !(tab.disabled || tab.active);

/**
 * @deprecated We must implement new https://zeroheight.com/3d3aa52b0/p/177171-steps into hivebrite_js
 */
const Steps = ({ navigation, divider }) => (
  <Box flexWrap="wrap">
    {navigation.map((tab, index) => (
      <Fragment key={tab.name}>
        <Step
          tabIndex={isItemClickable(tab) ? 0 : -1}
          onClick={isItemClickable(tab) ? tab.onClick : null}
          onKeyPress={isItemClickable(tab) ? onEnterPress(tab.onClick) : null}
          active={tab.active}
          disabled={tab.disabled}
        >
          {tab.name}
        </Step>
        {index + 1 !== navigation.length && <Box mx={1}>{divider}</Box>}
      </Fragment>
    ))}
  </Box>
);

Steps.propTypes = {
  navigation: PropTypes.array.isRequired,
  divider: PropTypes.string,
};

Steps.defaultProps = {
  divider: '>',
};

export default Steps;

const Step = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => !['active', 'disabled'].includes(prop),
  })
  .attrs(({ active }) => ({
    color: active && 'link',
    font: 'body-semibold-asphalt',
  }))`
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  position: relative;
  cursor: ${(props) => (isItemClickable(props) ? 'pointer' : '')};
  white-space: nowrap;
  min-height: 22px;
  margin-bottom: ${({ theme }) => theme.space[2]}px;
  transition: 0.2s color;

  ${(props) =>
    !props.disabled &&
    css`
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: ${props.theme.colors.link};
        transition: 0.2s opacity;
        opacity: 0;
      }

      &:hover {
        color: ${props.theme.colors.link};
        &:after {
          opacity: 1;
        }
      }
    `}

  ${(props) =>
    props.active &&
    css`
      &:after {
        opacity: 1;
      }
    `}
`;
